import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconInfo: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 13.6667C11.1296 13.6667 13.6667 11.1296 13.6667 8C13.6667 4.87039 11.1296 2.33333 8 2.33333C4.87039 2.33333 2.33333 4.87039 2.33333 8C2.33333 11.1296 4.87039 13.6667 8 13.6667Z"
    />
    <path
      d="M8 7.33333V10.6667"
    />
    <path
      d="M8 5.2H8.00667"
    />
  </svg>
);

export {
  IconInfo,
};
